// const isProd = process.env.NODE_ENV === 'production';

const ZingTouch = require('zingtouch');
const mediator = require('./mediator.js');
const Carusel = require('./carusel.js');
const target = document.getElementById('main-scene');
const carusel = new Carusel(target);

const Steps = require('./steps.js');
const stepsData = require('./step-data.js');
const steps = new Steps(stepsData);


const Modals = require('./modals.js');
const modals = new Modals(stepsData);
mediator.subscribe('modals:show', id => {
    modals.show(id);
});


let sprite;
if (!window.detectmob()) {
    sprite = require('./sprite-min.json');
} else {
    sprite = require('./sprite-mobile.json');
}

const spriteSheet = new window.createjs.SpriteSheet({
    framerate: 40,
    images: sprite.images,
    frames: sprite.frames
});

let mainSprite = new window.createjs.Sprite(spriteSheet);
mainSprite.mouseEnabled = false;
Object.defineProperty(mainSprite, "animationFrame", {
    get: function () {
        return this.currentFrame;
    },
    set: function (frame) {
        this.gotoAndStop(frame);
    }
});

const Progress = require('./progress.js');
let progress = new Progress(target, 5);
progress.hide();
/* mediator.subscribe('progress:newstep', step => {
    progress.step = step;
}); */

module.exports.progress = progress;



let startScene = () => {
    let countTime = (frame1, frame2, frameRate) => {
        return Math.abs(frame1 - frame2) * (1000 / (frameRate || 40));
    };

    let countProgress = (frame, minFrames, maxFrames) => {
        return (1 / ((maxFrames - minFrames) / frame) + minFrames) * 100;
    }

    let frameBorders = [0, 298];

    carusel.init(stage => {
        // let container = new window.createjs.Container();

        let canvasCoordinates = () => {
            return [
                stage.canvas.width >> 1,
                stage.canvas.height >> 1
            ];
        };
        // let canvasScale = () => {
        //     // let scale = Math.min(1, stage.canvas.width * 0.001);
        //     let scale = Math.min(1, stage.canvas.width * 0.0008);
        //     return [scale, scale];
        // };

        // let canvasRegs = () => {
        //     let scale = canvasScale();
        //     return [541, 541 * scale[1]];
        // };

        
        if (!window.detectmob()) {
            [mainSprite.regX, mainSprite.regY] = [541, 541];
        } else {
            [mainSprite.regX, mainSprite.regY] = [260, 260];
        }

        // [mainSprite.scaleX, mainSprite.scaleY] = canvasScale();
        [mainSprite.x, mainSprite.y] = canvasCoordinates();

        stage.addChild(mainSprite);
        mainSprite.gotoAndStop(0);

        progress.show();

        {
            // let firstWheel = true;
            // let lastStep;
            // let wheelHandler = event => {
            //     // if (firstWheel) {
            //     //     // modals.show(stepsData[0].id, 600);
            //     //     firstWheel = false;
            //     // } else {
                    
            //         let nextStep = parseInt(event.deltaY) > 0 ? steps.next : parseInt(event.deltaY) < 0 ? steps.prev : false;
                    
            //         if (nextStep && lastStep !== nextStep) {
            //             lastStep = nextStep;
            //             let activeStep = steps.active;
                        
            //             if (nextStep && nextStep.frame !== activeStep.frame) {
            //                 window.createjs.Tween
            //                 .get(mainSprite, { override: true })
            //                 .to({ animationFrame: nextStep.frame }, countTime(activeStep.frame, nextStep.frame))
            //                 .call(function () {
            //                     steps.active = nextStep;
            //                 });
            //             }
            //         }
            //     // }
            // };

            // let wheelHandler2 = event => {
            //     let nextStep = parseInt(event.deltaY) > 0 ? steps.next : parseInt(event.deltaY) < 0 ? steps.prev : false;
            // }
    
            if (!window.detectmob()) {
                // stage.canvas.addEventListener('wheel', wheelHandler, false);
                // stage.canvas.addEventListener('wheel', wheelHandler2, false);
            }
        }

        {
            let canvasZing = new ZingTouch.Region(carusel.touchElement);
            let panPaused = false;

            let pan = new ZingTouch.Pan();
            let startPan = pan.start;
            let endPan = pan.end;
            pan.start = (inputs) => {
                panPaused = false;
                return startPan.call(pan, inputs);
            };
            pan.end = (inputs) => {
                panPaused = false;

                let nextStep = steps.nearestStep(mainSprite.currentFrame);
                window.createjs.Tween
                    .get(mainSprite, { override: true })
                    .to({ animationFrame: nextStep.frame }, countTime(mainSprite.currentFrame, nextStep.frame))
                    .call(function () {
                        steps.active = nextStep;
                    });

                return endPan.call(pan, inputs);
            };

            
            canvasZing.bind(carusel.touchElement2, pan, () => {}, false);
            canvasZing.bind(carusel.touchElement2, 'pan', event => {
                if (!panPaused) {
                    let direction = event.detail.data[0].currentDirection;
                    let offset = 45;
                    let rightMove = direction >= 360 - offset && direction <= 360 || direction >= 0 && direction <= offset;
                    let leftMove = direction >= 180 - offset && direction <= 180 + offset;
                    let nextFrame;
                    let increse = 2;

                    if (rightMove) {
                        nextFrame = Math.max(Math.min(mainSprite.currentFrame - increse, frameBorders[1]), 0);
                        let minStep = steps.min;
                        if (nextFrame === minStep.frame) {
                            panPaused = true;
                        }
                        mainSprite.currentFrame = nextFrame;
                    }

                    if (leftMove) {
                        nextFrame = Math.max(Math.min(mainSprite.currentFrame + increse, frameBorders[1]), 0);
                        let maxStep = steps.max;
                        if (nextFrame === maxStep.frame) {
                            panPaused = true;
                        }
                        mainSprite.currentFrame = nextFrame;
                    }
                }
            }, false);
        }

        // window.addEventListener('resize', () => {
        //     [mainSprite.regX, mainSprite.regY] = [541, 541];
        //     [mainSprite.scaleX, mainSprite.scaleY] = canvasScale();
        //     [mainSprite.x, mainSprite.y] = canvasCoordinates();
        // });

    });

    progress.on('click', event => {
        let nextStep = steps.find( parseInt(event.target.dataset.step) );
        let activeStep = steps.active;

        if (nextStep && nextStep.frame !== activeStep.frame) {
            window.createjs.Tween
                .get(mainSprite, { override : true })
                .to({ animationFrame: nextStep.frame }, countTime(activeStep.frame, nextStep.frame))
                .call(function () {
                    steps.active = nextStep;
                });
        }
    });

    {
        let prevDirection;
        mediator.subscribe('steps:newstep', () => {
            prevDirection = false;
        });
        document.addEventListener('keydown', event => {
            let nextStep = event.key === "ArrowRight" ? steps.next : event.key === "ArrowLeft" ? steps.prev : false;
            let activeStep = steps.active;

            if (prevDirection !== event.key && nextStep && nextStep.frame !== activeStep.frame) {
                prevDirection = event.key;
                window.createjs.Tween
                    .get(mainSprite, { override: true })
                    .to({ animationFrame: nextStep.frame }, countTime(activeStep.frame, nextStep.frame))
                    .call(function () {
                        steps.active = nextStep;
                    });
            }
        });
    }

    let scrollPauseLeft = false;
    mediator.subscribe('modals:firstscroll', () => {
        if (!scrollPauseLeft) {
            scrollPauseLeft = true;
            scrollPauseRight = false;
            let nextStep = steps.prev;
            let activeStep = steps.active;

            if (nextStep) {
                window.createjs.Tween
                    .get(mainSprite, { override: true })
                    .to({ animationFrame: nextStep.frame }, countTime(activeStep.frame, nextStep.frame))
                    .call(function () {
                        steps.active = nextStep;
                        scrollPauseLeft = false;
                    });
            }
        }
    });
    let scrollPauseRight = false;
    mediator.subscribe('modals:lastscroll', () => {
        if (!scrollPauseRight) {
            scrollPauseRight = true;
            scrollPauseLeft = false;
            let nextStep = steps.next;
            let activeStep = steps.active;
    
            if (nextStep) {
                window.createjs.Tween
                    .get(mainSprite, { override: true })
                    .to({ animationFrame: nextStep.frame }, countTime(activeStep.frame, nextStep.frame))
                    .call(function () {
                        steps.active = nextStep;
                        scrollPauseRight = false;
                    });
            }
        }
    });
    
    {
        let lastFrame;
        carusel.tick(() => {
            if (lastFrame !== mainSprite.currentFrame) {
                progress.percent = countProgress(mainSprite.currentFrame, frameBorders[0], frameBorders[1]);
            }
        });
    }

    if (window.detectmob()) {
        modals.show(stepsData[0].id);
    } else {
        mediator.publish('steps:setactive', steps.active);
        mediator.publish('modals:show', steps.active.id);
    }
}
module.exports.startScene = startScene;


// WEBPACK FOOTER //
// ./js/carusel-logic.js